import { BaseComponent } from 'project/general';
import './owlcarousel2-progressbar';

class RelatedNewsSliderComponent extends BaseComponent {

    static getNamespace() {
        return 'related-news-slider';
    }

    onInit() {
        var owlNews = $(this.element);
        var owlID = owlNews.attr("id");

        $(owlNews).owlCarouselProgressBar({
            size: '3px',
            margin: '20px 0 0',
            borderRadius: 2.5,
            foregroundColor: '#d0c0ef',
            color: '#4203bf',
            transitionInterval: 1,
            progressBarClassName: 'scrollbar',
            scrollerClassName: 'scrollbar__scroller'
        });

        owlNews.owlCarousel({
            margin: 30,
            nav: false,
            dots: false,
            autoHeight: true,
            smartSpeed: 500,
            responsive: {
                0: {
                    items: 1,
                },
                600: {
                    items: 2,
                },
                1000: {
                    items: 3,
                    smartSpeed: 1000
                }
            },
            onInitialized: function (event) {
                $(owlNews).find('.owl-item').attr('aria-selected', 'false');
                $(owlNews).find('.owl-item.active').attr('aria-selected', 'true'); // let screen readers know an item is active

                // apply meta info to next and previous buttons and make them focusable
                $(owlNews).parent().find('.owl-buttons__button--owl-next').attr('role', 'button').attr('title', 'Previous');
                $(owlNews).parent().find('.owl-buttons__button--owl-next').attr('title', 'Next');
                $(owlNews).attr('tabindex', '0');
                $('.owl-buttons__button--owl-next, .owl-buttons__button--owl-prev').attr('tabindex', '0');

                // listen for keyboard input
                $(document).on('keydown', function (e) {

                    var $focusedElement = $(document.activeElement),
                        singleOwl = $(owlNews).data('owlCarousel'),
                        type = e.which == 39 ? 'next' : null,
                        type = e.which == 37 ? 'prev' : type,
                        type = e.which == 13 ? 'enter' : type;


                    // if the carousel is focused, use left and right arrow keys to navigate
                    if ($focusedElement.attr('id') === owlID) {
                        if (type == 'next') {
                            owlNews.trigger('next.owl.carousel');
                        } else if (type == 'prev') {
                            owlNews.trigger('prev.owl.carousel');
                        }

                        // if the prev and next buttons are focused, catch "Enter" and navigate in the right direction
                    } else if (type == 'enter') {
                        if ($focusedElement.attr('id') ===  owlID + '-next') {
                            owlNews.trigger('next.owl.carousel');
                        } else if ($focusedElement.attr('id') ===  owlID + '-prev') {
                            owlNews.trigger('prev.owl.carousel');
                        }
                    }
                });
            }
        });

        // Button actions for next & Prev
        $(owlNews).parent().find('#' + owlID + '-next').click(function () {
            owlNews.trigger('next.owl.carousel');
        });
        $(owlNews).parent().find('#' + owlID + '-prev').click(function () {
            owlNews.trigger('prev.owl.carousel');
        });
    }

}

export default RelatedNewsSliderComponent;
